import { ActionControllerEventName } from "@g.frame/common.action_controller";
import { ParentEvent } from "@g.frame/core";
import { Euler, Group, Vector2, Vector3 } from "three";
import Stage from "../Stage";
import TooltipComponent from "../../modules/tooltip/TooltipComponent";
const objectNameTags = [
    {
        obj_name: 'Wood_board004',
        tooltip_name: 'leaves_tooltip',
        level_hash: '#LeavesLevel'
    },
    {
        obj_name: 'main_body007',
        tooltip_name: 'tracktor_tooltip',
        level_hash: '#TractorLevel'
    },
    {
        obj_name: 'SM_AlchemyWoodTable004',
        tooltip_name: 'injection_tooltip',
        level_hash: '#InjectionLevel'
    }
];
export default class Lobby extends Stage {
    constructor(modulesProcessor, uiManager, environment) {
        super(modulesProcessor, uiManager, environment);
        this.modulesProcessor = modulesProcessor;
        this.uiManager = uiManager;
        this.environment = environment;
        this.tooltipList = [];
        this.materialsToHover = [];
        this.mainContainer = new Group;
        this.lobbyMenuActive = false;
        this.controlsPosition = {
            camera: new Vector3(8.088, 2, 10.604),
            target: new Vector3(8.03, 2, 10.53)
        };
        this.addObject(this.mainContainer);
    }
    init() {
        this.initAssets();
        this.prepareHovers();
        this.once('start_level', () => {
            this.completed = true;
            this.uiManager.hidePopUpScreen();
            this.lobbyMenuActive = true;
        });
    }
    startLevel() {
        if (!this.completed) {
            this.showStartMessage();
        }
        else {
            this.uiManager.hidePopUpScreen();
            this.lobbyMenuActive = true;
        }
    }
    initAssets() {
        this.environment.environment.traverse((item) => {
            objectNameTags.forEach((object) => {
                if (item.name === object.obj_name) {
                    item.userData = {
                        level_hash: object.level_hash
                    };
                }
            });
        });
    }
    prepareHovers() {
        this.environment.environment.traverse((item) => {
            objectNameTags.forEach((object) => {
                if (item.name === object.obj_name && item.material) {
                    const material = item.material;
                    this.materialsToHover.push({
                        name: object.tooltip_name,
                        material: material
                    });
                    this.actionController.on(ActionControllerEventName.over, item, () => {
                    });
                    this.actionController.on(ActionControllerEventName.move, item, () => {
                        if (this.lobbyMenuActive) {
                            this.checkTooltipName(object.tooltip_name);
                        }
                    });
                    this.actionController.on(ActionControllerEventName.out, item, () => {
                        if (this.lobbyMenuActive) {
                            this.checkTooltipName('');
                        }
                    });
                    this.actionController.on(ActionControllerEventName.click, item, (event) => {
                        if (event.data.intersection.orderNumber !== 0)
                            return;
                        if (this.lobbyMenuActive) {
                            this.checkTooltipName('');
                            this.lobbyMenuActive = false;
                            this.fire('next_level', new ParentEvent('next_level', { level: item.userData.level_hash || '#Lobby' }));
                        }
                    });
                }
            });
        });
        this.prepareTooltips();
    }
    prepareTooltips() {
        const tooltipsConfig = [
            {
                name: 'tracktor_tooltip',
                text: 'Vehicle Maintenance',
                level_hash: '#TractorLevel',
                position: new Vector3(0, 3.3, 6),
                rotation: new Euler(0, 0.9, 0),
                scale: 1,
                textScale: 1,
            },
            {
                name: 'leaves_tooltip',
                text: 'Crop Leaf Identification',
                level_hash: '#LeavesLevel',
                position: new Vector3(2.5, 2.9, 1),
                rotation: new Euler(0, 0.3, 0),
                scale: 1.45,
                textScale: 1.15,
            },
            {
                name: 'injection_tooltip',
                text: 'Administer an Injection',
                level_hash: '#InjectionLevel',
                position: new Vector3(2.5, 2.05, -11.5),
                rotation: new Euler(0, 0.3, 0),
                scale: 2.45,
                textScale: 1.15,
            },
        ];
        tooltipsConfig.forEach((tpconf) => {
            const tooltip = new TooltipComponent({
                text: tpconf.text,
                size: new Vector2(1.6, 0.4),
                textScale: tpconf.textScale,
                pxScale: 0.45,
            }, this.modulesProcessor);
            tooltip.init();
            tooltip.uiObject.position.copy(tpconf.position);
            tooltip.uiObject.rotation.copy(tpconf.rotation);
            tooltip.uiObject.scale.setScalar(tpconf.scale);
            this.tooltipList.push({
                name: tpconf.name,
                tooltip: tooltip
            });
            this.actionController.on(ActionControllerEventName.over, tooltip.uiObject, () => {
            });
            this.actionController.on(ActionControllerEventName.move, tooltip.uiObject, () => {
                if (this.lobbyMenuActive) {
                    this.checkTooltipName(tpconf.name);
                }
            });
            this.actionController.on(ActionControllerEventName.out, tooltip.uiObject, () => {
                if (this.lobbyMenuActive) {
                    this.checkTooltipName('');
                }
            });
            this.actionController.on(ActionControllerEventName.click, tooltip.uiObject, (event) => {
                if (event.data.intersection.orderNumber !== 0)
                    return;
                if (this.lobbyMenuActive) {
                    this.checkTooltipName('');
                    this.lobbyMenuActive = false;
                    this.fire('next_level', new ParentEvent('next_level', { level: tpconf.level_hash || '#Lobby' }));
                }
            });
            this.mainContainer.add(tooltip.uiObject);
        });
    }
    checkTooltipName(name) {
        if (!this.lobbyMenuActive)
            return;
        this.tooltipList.forEach((tp) => {
            if (tp.name === name) {
                // tp.tooltip.uiObject.visible = true;
                tp.tooltip.setHovered(true);
            }
            else {
                // tp.tooltip.uiObject.visible = false;
                tp.tooltip.setHovered(false);
            }
        });
        this.materialsToHover.forEach(mh => {
            if (mh.name === name) {
                mh.material.color.set('#00dd00');
            }
            else {
                mh.material.color.set('#ffffff');
            }
        });
    }
}
